const TONES = {
  muted: 'text-muted-foreground',
  primary: 'text-primary',
  projected: 'text-[hsl(var(--projected))]',
} as const;

/** The concept's section label: mono, uppercase, widely tracked. */
export const Eyebrow: React.FC<{
  children: React.ReactNode;
  tone?: keyof typeof TONES;
  className?: string;
}> = ({ children, tone = 'muted', className = '' }) => (
  <div
    className={`font-mono text-[9.5px] font-medium uppercase leading-none tracking-[0.14em] ${TONES[tone]} ${className}`}
  >
    {children}
  </div>
);
